import { render, staticRenderFns } from "./ReadyStepStoreType.vue?vue&type=template&id=6f988d71&"
import script from "./ReadyStepStoreType.vue?vue&type=script&lang=js&"
export * from "./ReadyStepStoreType.vue?vue&type=script&lang=js&"
import style0 from "./ReadyStepStoreType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports